module.exports = __webpack_public_path__ + "assets/img/pigeon-hit.a116f155.png";